<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <a class="decoration">Rental</a>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Rental Calendar
      </h6>

      <div class="calendar-shell custom_bdr_rds ">
        <div class="calendar-toolbar mt-2 custom_bdr_rds">
          <button class="month-btn background_color2" title="Previous Month" @click="previousMonth">
            <i class="fa fa-chevron-left" aria-hidden="true"></i>
          </button>
          <h5>Rental Unit Calender - {{ monthName }}-{{ currentYear }}</h5>
          <button class="month-btn background_color2" title="Next Month" @click="nextMonth">
            <i class="fa fa-chevron-right" aria-hidden="true"></i>
          </button>
        </div>

        <div class="legend-row">
          <span class="legend-item"><span class="legend-box booked"></span>Booked Item</span>
          <span class="legend-item"><span class="legend-box not-returned"></span>Still Not returned</span>
          <span class="legend-item"><span class="legend-box extended"></span>Extended</span>
        </div>

        <div v-if="isLoading" class="loading-wrap">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <div v-else class="calendar-table-wrap">
          <table class="rental-calendar-table ">
            <thead>
              <tr>
                <th class="item-heading">Item</th>
                <th v-for="day in daysInMonth" :key="day" class="day-heading">
                  <span class="day-number">{{ padDay(day) }}</span>
                  <span class="day-name">{{ dayName(day) }}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td class="item-cell">
                  <a style="color: #000;" class="" @click.prevent="viewGin(item.gin_id)" href="#">
                    {{ item.model_name || item.item || "-" }}
                  </a>
                </td>
                <td
                  v-for="day in daysInMonth"
                  :key="item.id + '-' + day"
                  :class="['day-cell', getCellClass(item, day)]"
                  :title="getCellTitle(item, day)"
                >
                  <span
                    v-if="getCellClass(item, day)"
                    class="timeline-bar"
                  ></span>
                </td>
              </tr>
              <tr v-if="items.length === 0">
                <td :colspan="daysInMonth.length + 1" class="empty-cell">No rental units found for this month.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <br />
    </div>
    
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  name: "RentalCalender",
  components: {
    TopNavbar,
    ContentFooter,
  },
  data() {
    const today = new Date();
    return {
      access_token: authService.isLoggedIn(),
      currentMonth: today.getMonth(),
      currentYear: today.getFullYear(),
      items: [],
      isLoading: true,
    };
  },
  computed: {
    monthName() {
      return new Date(this.currentYear, this.currentMonth, 1).toLocaleString("en-US", {
        month: "long",
      });
    },
    daysInMonth() {
      return new Date(this.currentYear, this.currentMonth + 1, 0).getDate();
    },
    monthStart() {
      return this.toDateOnly(new Date(this.currentYear, this.currentMonth, 1));
    },
    monthEnd() {
      return this.toDateOnly(new Date(this.currentYear, this.currentMonth + 1, 0));
    },
  },
  mounted() {
    this.loadCalendar();
  },
  methods: {
    padDay(day) {
      return String(day).padStart(2, "0");
    },
    dayName(day) {
      return new Date(this.currentYear, this.currentMonth, day).toLocaleString("en-US", {
        weekday: "short",
      }).slice(0, 2);
    },
    toDateOnly(date) {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    },
    parseDate(value) {
      if (!value || value === "0000-00-00") {
        return null;
      }

      const parts = value.split("-").map(Number);
      if (parts.length !== 3 || !parts[0] || !parts[1] || !parts[2]) {
        return null;
      }

      return new Date(parts[0], parts[1] - 1, parts[2]);
    },
    getDisplayRange(item) {
      const fromDate = this.parseDate(item.from_date) || this.parseDate(item.issue_date);
      const toDate = this.parseDate(item.to_date) || fromDate;
      const returnDate = this.parseDate(item.return_date);
      const extendTo = this.parseDate(item.extend_to);
      const today = this.toDateOnly(new Date());

      if (!fromDate) {
        return null;
      }

      let endDate = toDate || fromDate;
      let startDate = fromDate;

      if (item.state === "extended" && extendTo && extendTo > endDate) {
        endDate = extendTo;
      } else if (item.state === "not_returned" && !toDate && !returnDate) {
        endDate = today > fromDate ? today : fromDate;
      } else if (returnDate && returnDate < endDate) {
        endDate = returnDate;
      }

      return { startDate, endDate };
    },
    getCellClass(item, day) {
      const range = this.getDisplayRange(item);
      if (!range) {
        return "";
      }

      const cellDate = new Date(this.currentYear, this.currentMonth, day);
      if (cellDate < range.startDate || cellDate > range.endDate) {
        return "";
      }

      if (item.state === "extended") {
        return "cell-extended";
      }

      if (item.state === "not_returned") {
        return "cell-not-returned";
      }

      return "cell-booked";
    },
    getCellTitle(item, day) {
      if (!this.getCellClass(item, day)) {
        return "";
      }

      return `${item.issue_no || ""} ${item.customer_name || ""} ${item.model_name || item.item || ""}`.trim();
    },
    async loadCalendar() {
      this.isLoading = true;
      try {
        const headers = {
          Authorization: "Bearer " + this.access_token,
          "Content-type": "application/json",
        };
        const { data } = await axios.get("/rentalgin/rentalcalendar", {
          params: {
            month: this.currentMonth + 1,
            year: this.currentYear,
          },
          headers,
        });

        const seen = new Set();
        this.items = (data.items || []).filter((item) => {
          const key = `${item.id || ""}-${item.gin_id || ""}`;
          if (seen.has(key)) {
            return false;
          }
          seen.add(key);
          return true;
        });
      } catch (error) {
        console.log(error.response || error);
        this.items = [];
      } finally {
        this.isLoading = false;
      }
    },
    previousMonth() {
      if (this.currentMonth === 0) {
        this.currentMonth = 11;
        this.currentYear -= 1;
      } else {
        this.currentMonth -= 1;
      }

      this.loadCalendar();
    },
    nextMonth() {
      if (this.currentMonth === 11) {
        this.currentMonth = 0;
        this.currentYear += 1;
      } else {
        this.currentMonth += 1;
      }

      this.loadCalendar();
    },
    viewGin(id) {
      if (id) {
        this.$router.push("/rental/gin?id=" + id);
      }
    },
  },
};
</script>

<style scoped>
.calendar-shell {
  margin: 8px 16px 120px;
  padding: 0 12px 14px;
  border: 1px solid #e4e8ef;
  border-radius: 6px;
  background: #fff;
  overflow-x: auto;
  box-shadow: 0 2px 10px rgba(22, 35, 52, 0.06);
}

.calendar-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 44px;
  padding-top: 4px;
}

.calendar-toolbar h5 {
  margin: 0;
  flex: 1;
  color: #0068c9;
  text-align: center;
  font-weight: 700;
  font-size: 16px;
}

.month-btn {

  color: #fff;
  border: 0;
  width: 34px;
  height: 34px;
  padding: 0;
  font-size: 14px;
  line-height: 1.2;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: none;
}

.month-btn:hover {
  background: #5d9ff0;
}

.legend-row {
  display: flex;
  justify-content: center;
  gap: 34px;
  align-items: center;
  margin: 0 0 8px;
  font-size: 13px;
}

.legend-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.legend-box {
  width: 18px;
  height: 10px;
  border-radius: 8px;
  display: inline-block;
}

.legend-box.booked,
.cell-booked .timeline-bar {
  background: #f59f00;
}

.legend-box.not-returned,
.cell-not-returned .timeline-bar {
  background: #1f7ae0;
}

.legend-box.extended,
.cell-extended .timeline-bar {
  background: #55cc6b;
}

.legend-box.booked {
  background: #f59f00;
}

.legend-box.not-returned {
  background: #1f7ae0;
}

.legend-box.extended {
  background: #55cc6b;
}

.loading-wrap {
  display: flex;
  justify-content: center;
  padding: 40px;
}

.calendar-table-wrap {
  min-width: 1080px;
  border: 1px solid #e5e8ee;
  border-radius: 4px;
  overflow: hidden;
}

.rental-calendar-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 13px;
}

.rental-calendar-table th,
.rental-calendar-table td {
  border: 1px solid #e1e5ec;
}

.item-heading {
  width: 260px;
  background: #fff;
  text-align: left;
  padding: 7px 10px;
  font-weight: 600;
  color: #27313f;
  position: sticky;
  left: 0;
  z-index: 3;
}

.day-heading {
  width: 32px;
  background: #fff;
  text-align: center;
  padding: 4px 0 3px;
  font-weight: 700;
  color: #2f3a47;
  vertical-align: bottom;
}

.day-number,
.day-name {
  display: block;
  line-height: 1.15;
}

.day-number {
  font-size: 12px;
}

.day-name {
  margin-top: 2px;
  color: #7b8490;
  font-size: 9px;
  font-weight: 500;
}

.item-cell {
  height: 38px;
  padding: 0 10px;
  background: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: sticky;
  left: 0;
  z-index: 2;
}

tbody tr:nth-child(even) .item-cell {
  background: #f8fbff;
}

.item-link {
  color: #007bff;
  cursor: pointer;
  text-decoration: none;
  line-height: 38px;
  font-size: 12px;
  font-weight: 500;
}

.day-cell {
  height: 38px;
  background: #fff;
  padding: 0;
  position: relative;
}

tbody tr:nth-child(even) .day-cell {
  background: #f8fbff;
}

.day-cell:nth-child(7n + 1),
.day-cell:nth-child(7n + 2) {
  background: #f1f4f8;
}

.timeline-bar {
  position: absolute;
  inset: 0;
  display: block;
  border-radius: 6px;
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.08);
}

.empty-cell {
  height: 44px;
  text-align: center;
  color: #777;
}

.manage-boder {
  border-bottom: 2px solid #e9e9e3;
  border-top: 2px solid #e9e9e3;
  padding-bottom: 10px !important;
  padding-top: 10px !important;
}

.font1 {
  font-size: 13px !important;
}

.decoration {
  text-decoration: none;
  color: #a5a5a3;
}
</style>
